let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8itUN")).then(() => parcelRequire('eY8z7'));